<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%; margin-top: 10px">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>收益记录</h3>
          </div>
          <div class="table-title-btn">
            <el-button v-allow="'090302'" type="primary" class="adduser" @click="add">添加</el-button>
            <!-- <el-button type="primary" class="adduser" @click="handleReturn">返回决策模型</el-button> -->
          </div>
        </div>

        <!-- <div style="margin-bottom:10px;margin-left:10px">
        </div> -->
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column align="center" label="作物名称">
              <template slot-scope="scope">
                <p>{{ scope.row.cropName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="正常价格">
              <template slot-scope="scope">
                <p>{{ scope.row.normalPrice }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="正常数量（斤）">
              <template slot-scope="scope">
                <p>{{ scope.row.normalNum }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="次果价格">
              <template slot-scope="scope">
                <p>{{ scope.row.imperfectPrice }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="次果数量（斤）">
              <template slot-scope="scope">
                <p>{{ scope.row.imperfectNum }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="小果价格">
              <template slot-scope="scope">
                <p>{{ scope.row.smallPrice }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="小果数量（斤）">
              <template slot-scope="scope">
                <p>{{ scope.row.smallNum }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="总收益">
              <template slot-scope="scope">
                <p>{{ scope.row.income }}/元</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="日期">
              <template slot-scope="scope">
                <p>{{ scope.row.date }}</p>
              </template>
            </el-table-column>

            <!-- <el-table-column align="center" label="农事视频">
              <template slot-scope="scope">
                <video :src="scope.row.workVideo" width="120" height="80" controls>
                </video>
              </template>

            </el-table-column> -->

            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleClickRole(scope.row.id, 'edit')" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="delRole(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" :before-close="resetForm" width="800px" style="z-index: 10000" center>
        <div style="padding: 5px 50px 30px 10px" class="info-content-container info-content-container-add">
          <el-form :model="dialogformInline" :rules="dialogRules" label-width="140px" ref="REFdialogformInline">
            <el-row>
              <el-col :span="12">
                <el-form-item label="时间：">
                  <el-date-picker v-model="dialogformInline.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"> </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="作物名称：">
                  <el-select v-model="dialogformInline.cropId" clearable placeholder="请选择">
                    <el-option v-for="item in Crops" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="次果价格：" prop="imperfectPrice">
                  <el-input v-model="dialogformInline.imperfectPrice" placeholder="请输入次果价格" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="次果数量（斤）：" prop="imperfectNum">
                  <el-input v-model="dialogformInline.imperfectNum" placeholder="请输入次果数量（斤）" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="正常价格：" prop="normalPrice">
                  <el-input v-model="dialogformInline.normalPrice" placeholder="请输入正常价格" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="正常数量（斤）：" prop="normalNum">
                  <el-input v-model="dialogformInline.normalNum" placeholder="请输入正常数量（斤）" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="小果价格：" prop="smallPrice">
                  <el-input v-model="dialogformInline.smallPrice" placeholder="请输入小果价格" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="小果数量（斤）：" prop="smallNum">
                  <el-input v-model="dialogformInline.smallNum" placeholder="请输入小果数量（斤）" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm">取 消</el-button>
          <el-button type="primary" @click="submitForm('REFdialogformInline')">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入数据" :visible.sync="importDialog" width="500px" :before-close="handleCloseImport">
        <div class="equipmentcenter-opption-box">
          <el-form ref="importForm" label-width="0px">
            <el-form-item label="" style="width: 100%">
              <el-upload class="upload-demo" :action="$serverUrl + '/pc/productionWork/importProductionWork'" :headers="headers" name="fileName" :before-upload="handleChange" :on-success="handleAvatarSuccess" :limit="1" :file-list="importFileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传excel（.xls和.xlsx）文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import UploadImg from '@/components/upload/MultipleImgUpload.vue'
import UploadVideo from '@/components/upload/UploadVideo.vue'
import moment from 'moment'
export default {
  components: { UploadImg, UploadVideo },

  data() {
    return {
      headers: {
        // 请求头
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      Fertilizers: [],
      Staffs: [],
      Pesticides: [],
      Devices: [],
      Crops: [],
      date: '',
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        startTime: '',
        endTime: '',
        cropName: '',
        cropId: '',
        deviceId: '',
        fertilizerId: '',
        pesticideId: '',
        income: ''
      },
      dialogformInline: {
        //添加，编辑（参数）
        id: '',
        cropId: '',
        date: '',
        imperfectNum: '',
        imperfectPrice: '',
        normalNum: '',
        normalPrice: '',
        smallNum: '',
        smallPrice: ''
      },
      dialogRules: {
        // 弹框表单验证
        workTypeId: [{ required: true, message: '请选择农事类型', trigger: 'change' }],
        imperfectNum: [{ required: true, message: '请输入', trigger: 'blur' }],
        imperfectPrice: [{ required: true, message: '请输入', trigger: 'blur' }],
        normalNum: [{ required: true, message: '请输入', trigger: 'blur' }],
        normalPrice: [{ required: true, message: '请输入', trigger: 'blur' }],
        smallNum: [{ required: true, message: '请输入', trigger: 'blur' }],
        smallPrice: [{ required: true, message: '请输入', trigger: 'blur' }],

        groupId: [{ required: true, message: '请选择分组', trigger: 'change' }]
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // cropName: [{ required: true, message: '请输入角色', trigger: 'change' }]
      },
      groupIdArr: [],
      groupIdArr_: [],
      alarmTime: '',
      alarmTime_: [],
      total: 0, // 总数
      tableData: [],
      importDialog: false,
      loading: false,
      groupArray: [], // 分组数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      options: [],
      editId: '', //编辑id
      loading: false,
      dialogTitle: '',
      centerDialogVisible: false //添加弹框
    }
  },
  created() {
    // 查询
    this.getList()
    this.getProductionCrops()
  },
  methods: {
    // 导入
    handleImport() {
      this.$confirm('导入数据会在原有数据上进行新增，不会影响已有数据，是否继续导入？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.importDialog = true
        })
        .catch(() => {
          this.$message.info('已取消导入')
        })
    },
    // 关闭导入弹窗
    handleCloseImport() {
      this.importDialog = false
    },
    addType(url) {
      this.$router.push({
        path: `/${url}`
      })
    },
    addType1() {
      this.$router.push({
        path: '/deviceManagement'
      })
    },
    resetForm() {
      this.centerDialogVisible = false
      // this.$refs['REFdialogformInline'].resetFields();
      this.groupIdArr_ = []
      this.dialogformInline = {
        id: '',
        cropId: '',
        date: '',
        imperfectNum: '',
        imperfectPrice: '',
        normalNum: '',
        normalPrice: '',
        smallNum: '',
        smallPrice: ''
      }
      this.date = ''
    },
    add() {
      this.resetForm()

      this.dialogTitle = '添加'
      this.centerDialogVisible = true
    },
    // 上传图片
    setImg(url) {
      this.dialogformInline.workImage = url
    },
    upSuccess(data) {
      this.dialogformInline.imagesArr = data
    },
    // 上传视频
    setVideo(data) {
      this.dialogformInline.workVideo = data
    },
    exoprtExcel() {
      this.$api.growthModel.exportProductionWorkList(this.searchForm).then(res => {
        if (res.code == 200) {
          window.open(res.data)
        }
      })
    },
    // 新增或者编辑
    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate(valid => {
        if (valid) {
          // this.dialogformInline.endTime = this.alarmTime[1]
          this.$api.system.saveGrowthCropIncomeData(this.dialogformInline).then(res => {
            this.alarmTime = []
            if (res.code == 200) {
              this.loading = false
              this.centerDialogVisible = false
              this.$message({ type: 'success', message: res.msg })
              this.getList()
            } else {
              this.loading = false
            }
          })
        } else {
          return false
        }
      })
    },
    handleClickRole(id, type) {
      //编辑

      if (type == 'edit') {
        this.editId = id // 编辑id
        this.dialogTitle = '编辑'
        this.getProductionWork(id)
      }
    },
    //列表数据编辑获取信息
    getProductionWork(id) {
      this.$api.system.getGrowthCropIncomeData({ id: id }).then(res => {
        if (res.code == 200) {
          this.dialogformInline = res.data
          this.centerDialogVisible = true
        } else {
          this.loading = false
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map(item => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    delRole(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(22)
          this.$api.system.delfun(`/pc/growthCropIncomeData/delGrowthCropIncomeData`, id).then(res => {
            console.log(112)
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.getList()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        startTime: '',
        endTime: ''
      }
      this.groupIdArr = []

      this.alarmTime_ = []
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    getProductionWorkTypes() {
      this.$api.growthModel.getProductionWorkTypes().then(res => {
        if (res.code == 200) {
          this.options = res.data
        }
      })
    },
    // 作物信息
    getProductionCrops(id) {
      this.$api.system.getAllGrowthCrops({ id }).then(res => {
        if (res.code == 200) {
          this.Crops = res.data
        }
      })
    },
    // 设备
    getProductionDevices() {
      this.$api.growthModel.getProductionDevices().then(res => {
        if (res.code == 200) {
          this.Devices = res.data
        }
      })
    },
    // 农药
    getProductionPesticides() {
      this.$api.growthModel.getProductionPesticides().then(res => {
        if (res.code == 200) {
          this.Pesticides = res.data
        }
      })
    },
    // 员工
    getProductionStaffs() {
      this.$api.growthModel.getProductionStaffs().then(res => {
        if (res.code == 200) {
          this.Staffs = res.data
        }
      })
    },
    // 肥料
    getProductionFertilizers() {
      this.$api.growthModel.getProductionFertilizers().then(res => {
        if (res.code == 200) {
          this.Fertilizers = res.data
        }
      })
    },
    // 分页获取列表
    getList() {
      this.loading = true
      if (this.alarmTime_ && this.alarmTime_.length == 2) {
        this.searchForm.startTime = this.alarmTime_[0]
        this.searchForm.endTime = this.alarmTime_[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.$api.system.getGrowthCropIncomeDataList(this.searchForm).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          if (this.tableData.length == 0 && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1
            this.getList()
          }
          this.total = res.count
        }
        this.loading = false
      })
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then(res => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (!this.groupIdArr || this.groupIdArr.length != 2) {
        this.groupIdArr = []
        this.searchForm.groupId = ''
      } else {
        this.searchForm.groupId = this.groupIdArr[1]
      }
      this.getProductionCrops(this.searchForm.groupId)
      this.getList()
    },
    groupChange_() {
      if (!this.groupIdArr_ || this.groupIdArr_.length != 2) {
        this.groupIdArr_ = []
        this.dialogformInline.groupId = ''
      } else {
        this.dialogformInline.groupId = this.groupIdArr_[1]
      }
      this.getProductionCrops(this.dialogformInline.groupId)
    },
    // 推送模型转名称
    topushModel(pm) {
      return pm == undefined || pm == null ? '' : pm.toString().replace('0', '邮箱发送').replace('1', '短信发送').replace('2', 'APP推送').replace('3', '小程序推送').replace('4', '语音拨号提醒')
    }
  }
}
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 30px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
.cursipon {
  cursor: pointer;
}
.button_li {
  width: 100%;
  margin-left: 30px;
  display: flex;
  justify-content: right;
}
</style>
